import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { StorageService } from "src/services/storage.service";
import { environment } from "../../../environments/environment";
import { OwlOptions } from "ngx-owl-carousel-o";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-comprehensive-upload-doc",
  templateUrl: "./comprehensive-upload-doc.component.html",
  styleUrls: ["./comprehensive-upload-doc.component.css"],
})
export class ComprehensiveUploadDocComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
  };

  public slideIndex = 1;

  comprehensiveStatus = 2;
  pageTitle = "Comprehensive Request";
  policyDocumentUrl;
  moroorDocumentUrl;
  invoiceDocumentUrl;
  docContainerName: string = "comprehensive-policy-book";

  constructor(
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.loadImage();
  }

  loadImage(): void {
    this.storageService
      .getSASToken(
        this.route.snapshot.paramMap.get("id") + "_policy",
        this.docContainerName
      )
      .subscribe((token: any) => {
        const url =
          environment.cdnUrl +
          "/" +
          this.docContainerName +
          "/" +
          this.route.snapshot.paramMap.get("id") +
          "_policy" +
          token.sasToken;

        this.policyDocumentUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(url);
      });
  }

  goBack(): void {
    this.location.back();
  }

  print() {
    let url: any;
    switch (this.slideIndex) {
      case 1: {
        url = this.policyDocumentUrl;
        break;
      }
      case 2: {
        url = this.moroorDocumentUrl;
        break;
      }
      case 3: {
        url = this.invoiceDocumentUrl;
        break;
      }
    }

    this.storageService
      .getImage(url.changingThisBreaksApplicationSecurity)
      .subscribe((response) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
      });
  }
  done() {
    this.router.navigate([
      "/comprehensive-consumer-request/policy-status/" +
        this.route.snapshot.paramMap.get("id"),
    ]);
  }

  slideChange(index) {
    this.slideIndex = index;
  }

  public onSlide(slideData) {
    this.slideIndex = slideData.startPosition + 1;

    switch (this.slideIndex) {
      case 1: {
        if (this.policyDocumentUrl === undefined) {
          this.storageService
            .getSASToken(
              this.route.snapshot.paramMap.get("id") + "_policy",
              this.docContainerName
            )
            .subscribe((token: any) => {
              const url =
                environment.cdnUrl +
                "/" +
                this.docContainerName +
                "/" +
                this.route.snapshot.paramMap.get("id") +
                "_policy" +
                token.sasToken;
              this.policyDocumentUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(url);
            });
        }
        break;
      }

      case 2: {
        if (this.moroorDocumentUrl === undefined) {
          this.storageService
            .getSASToken(
              this.route.snapshot.paramMap.get("id") + "_moroor",
              this.docContainerName
            )
            .subscribe((token: any) => {
              const url =
                environment.cdnUrl +
                "/" +
                this.docContainerName +
                "/" +
                this.route.snapshot.paramMap.get("id") +
                "_moroor" +
                token.sasToken;
              this.moroorDocumentUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(url);
            });
        }
        break;
      }

      case 3: {
        if (this.invoiceDocumentUrl === undefined) {
          this.storageService
            .getSASToken(
              this.route.snapshot.paramMap.get("id") + "_invoice",
              this.docContainerName
            )
            .subscribe((token: any) => {
              const url =
                environment.cdnUrl +
                "/" +
                this.docContainerName +
                "/" +
                this.route.snapshot.paramMap.get("id") +
                "_invoice" +
                token.sasToken;
              this.invoiceDocumentUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(url);
            });
        }
      }
    }
    // your JS here
  }
}
